export enum CampusContactType {
    Principal = 1,
    AssistantPrincipal = 2,
    Mentor = 3,
    CampusSupervisor = 4,
}